// extracted by mini-css-extract-plugin
module.exports = {"footer":"_footernavigation_footer__1b66c","link":"_footernavigation_link__QJfWh"};